
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
$w.onReady(function () {
	 if (wixWindow.formFactor === "Mobile") {
        $w('#kibble').show();
		$w('#home').show();
		$w('#hb').show();
    } else { $w('#kibble').hide();
		$w('#home').hide();
		$w('#hb').hide(); 
    }
});